<template>
  <section class="distribution-form">
    <embed-frame
      class="distribution-form-frame"
      endpoint="public_simulator_distribution/form"
      placeholder="Carregando..."
      :settings="embedSettings"
      :callbacks="embedCallbacks"
    />
  </section>
</template>

<script>
  import EmbedFrame from '@sdk/views/Embed/Frame.vue';

  export default {
    name: 'DistributionForm',
    components: {
      EmbedFrame,
    },
    computed: {
      embedSettings() {
        return {
          public_simulator_distribution: {
            form: {
              store_id: this.$route.params.id,
            },
          },
        };
      },
      embedCallbacks() {
        return {
          'public_simulator_distribution:update': this.callback,
        };
      },
    },
    methods: {
      callback() {
        this.$router.push({
          name: 'settings-distribution-list',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .distribution-form {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }
</style>
